import React, {useState} from "react";
import {Outlet, useLocation} from "react-router-dom";
import {Header} from "@components/layout/Header";
import {Footer} from "@components/layout/Footer";
import UserData from "@helpers/userData";
import {useSelector} from "react-redux";
import {PreviewLoader, MobileSidebar} from "@components/library";
import {ConnectionToSockets} from "@components/common/ConnectionToSockets";
import {FUTURES_PAGE, MAIN_PAGE, NO_FOOTER_PAGES} from "@constants";
import "@components/library/Sidebar/sidebar.sass";

const LayoutWithAside = () => {
  const location = useLocation();
  const {loading} = useSelector((state) => state.user);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isTradePage = [MAIN_PAGE, FUTURES_PAGE].includes(location.pathname);

  return (
    <>
      <UserData/>

      {loading ? (
        <PreviewLoader loading={loading}/>
      ) : (
        <>
          <ConnectionToSockets/>
          <MobileSidebar open={sidebarOpen} setOpen={setSidebarOpen} />
          <div className={`base-wrap${isTradePage ? " base-wrap--trade" : ""}`}>
            <div className="base-wrap__header">
              <Header sidebarToggle={() => setSidebarOpen(!sidebarOpen)} />
            </div>

            <div className="base-wrap__content">
              <main className="main-content">
                <div className="main-content__wrapper full-width">
                  <Outlet/>
                </div>
              </main>
            </div>

            {!NO_FOOTER_PAGES.includes(location.pathname) && (
              <div className="base-wrap__footer">{<Footer/>}</div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default LayoutWithAside;
